import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/";
import Api from "./services/api";
import Skeleton from "vue-loading-skeleton";
import SkeletonTable from "./components/skeleton/SkeletonTable.vue";
import SkeletonBoxes from "./components/skeleton/SkeletonBoxes.vue";
import BxComponents from "./bx-components";
import "@/assets/scss/bx-components/bx-components.scss";
import "@/assets/scss/app.scss";
import i18n from "./lang";
import VueSession from "vue-session";
import vuetify from "./plugins/vuetify";
import "vue-datetime/dist/vue-datetime.css";

import VueApexCharts from "vue-apexcharts";
import infiniteScroll from "vue-infinite-scroll";
import "leaflet/dist/leaflet.css";
import common from "./utils/common";

Vue.component("apexchart", VueApexCharts);
Vue.component("skeleton-boxes", SkeletonBoxes);
Vue.component("skeleton-table", SkeletonTable);

Vue.use(infiniteScroll);
Vue.use(VueSession);
Vue.config.productionTip = false;
Vue.use(BxComponents);
Vue.use(Skeleton);
Vue.mixin(common);
Vue.use(Api, { store });

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
